"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BOMTotal_1 = __importDefault(require("./BOMTotal"));
exports.default = BOMTotal_1.default;
